/* eslint-disable */
export const PUSHER_CONFIG = {
    APP_KEY: process.env.REACT_APP_PUSHER_APP_KEY,
    CLUSTER: process.env.REACT_APP_PUSHER_CLUSTER,
    WS_HOST: process.env.REACT_APP_PUSHER_WS_HOST,
    WS_PORT: process.env.REACT_APP_PUSHER_WS_PORT,
    FORCE_SSL: process.env.REACT_APP_PUSHER_FORCE_SSL.toString() === '1',
};
